import React from 'react';
import styled from '@emotion/styled';
import { Card, Button } from 'antd';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import IconPng from '../../common/IconPng';
import { themeColors } from '../../../constants/themes';
import { colors, fontSize } from '../../../constants';
import IconSvg from '../../common/IconSvg';

export const CloseButton = ({ closeAction }) => (
  <IconSvg
    type="x"
    size={15}
    onClick={closeAction}
    css={css`
      position: absolute;
      top: 10px;
      right: 10px;
    `}
  />
);

const IndicationSpan = styled.span`
  font-family: Heebo;
  font-size: ${props => (props.fontSize ? props.fontSize : fontSize.large)};
  color: ${({ theme }) => theme.colors.blueDark};
`;

export const Indication1 = () => (
  <React.Fragment>
    <IndicationSpan fontSize={fontSize.huge}>1</IndicationSpan>
    &nbsp;
    <IndicationSpan>
      <FormattedMessage id="onboarding.screen4.selectMarketplace" />
    </IndicationSpan>
  </React.Fragment>
);

export const Indication2 = () => (
  <React.Fragment>
    <IndicationSpan fontSize={fontSize.huge}>2</IndicationSpan>
    &nbsp;
    <IndicationSpan>
      <FormattedMessage id="onboarding.screen4.selectLocation" />
    </IndicationSpan>
  </React.Fragment>
);

export const Indication3 = () => (
  <React.Fragment>
    <IndicationSpan fontSize={fontSize.huge}>3</IndicationSpan>
    &nbsp;
    <IndicationSpan>
      <FormattedMessage id="onboarding.screen4.introduceData" />
    </IndicationSpan>
  </React.Fragment>
);

export const Indication4 = () => (
  <React.Fragment>
    <IndicationSpan fontSize={fontSize.huge}>3</IndicationSpan>
    &nbsp;
    <IndicationSpan>
      <FormattedMessage id="connection.connectedDestinations" />
    </IndicationSpan>
  </React.Fragment>
);

export const CustomCard = styled(Card)`
  width: 108.8px;
  height: 55.1px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  margin-right: 14px;
  box-shadow: 0px 1px 7px 0 ${({ theme }) => theme.colors.imageBoxShadow};

  &.highlighted {
    border-top: 4px solid ${({ theme }) => theme.colors.blueDark};
  }

  background-color: #ffffff;

  &:hover {
    border-color: ${({ theme }) => theme.colors.blueMed};
    border-right-width: 1px !important;
    cursor: pointer;
  }
  & .ant-card-body {
    padding: 0;
  }
  & > .ant-card-cover > span {
    width: 100%;
    margin-top: 20px;
  }
`;

const MarketCard = props => (
  <CustomCard
    hoverable
    cover={<IconPng type={props.type} height={14.7} />}
    onClick={e => props.clickHandler(e)}
    className={props.highlighted ? 'highlighted' : undefined}
  />
);

MarketCard.propTypes = {
  highlighted: PropTypes.bool,
  type: PropTypes.string,
  clickHandler: PropTypes.func,
};

export { MarketCard };

const CustomIconPng = styled(IconPng)`
  border-radius: 50%;
  margin-right: 14px;
  box-shadow: 0 1px 7px 0 ${({ theme }) => theme.colors.imageBoxShadow};
  background-color: #ffffff !important;
  background-size: 160% !important;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.blueMed};
    background-position: -12px -12px !important;
    //cursor: pointer;// there is only one location available atm
    background-size: 175% !important;
  }

  &.highlighted {
    border: 4px solid ${({ theme }) => theme.colors.blueDark};
    background-position: -13px -13px !important;
    background-size: 204% !important;
  }
`;

const LocationFlag = props => (
  <CustomIconPng
    onClick={props.clickHandler}
    className={props.highlighted ? 'highlighted' : undefined}
    type={props.type}
    size={36}
  />
);

LocationFlag.propTypes = {
  highlighted: PropTypes.bool,
  type: PropTypes.string,
  clickHandler: PropTypes.func,
};

export { LocationFlag };

export const DestinationResultContainer = styled.div`
  width: 45%;
  margin-top: 8px;
  margin-left: ${({ hasAuto }) => (hasAuto ? 'auto' : '')};
  order: ${({ order }) => (order ? '7' : '2')};
`;

export const DestinationResultText = styled.span`
  font-family: Heebo;
  font-size: ${({ theme }) => theme.fontSize.medium};
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: ${props => (props.success ? themeColors.green : 'unset')};
`;

const ConnectAnother = props => {
  return (
    <a
      css={css`
        font-family: Roboto;
        font-size: ${fontSize.medium};
        color: ${colors.blueMed};
        text-decoration: underline;
      `}
      onClick={e => props.clickHandler(e)}
    >
      <FormattedMessage id="onboarding.screen4.connectAnother" />
    </a>
  );
};

ConnectAnother.propTypes = {
  clickHandler: PropTypes.func,
};

const ConnectAccount = props => {
  return (
    <Button
      css={css`
        position: fixed;
        right: 85px;
        top: 270px;
        width: 134px;
        box-shadow: 0 3px 6px 0 ${colors.colorlessBoxShadow};
      `}
      onClick={e => props.clickHandler(e)}
    >
      <FormattedMessage id="onboarding.screen4.connectAccount" />
    </Button>
  );
};

ConnectAccount.propTypes = {
  clickHandler: PropTypes.func,
};

export const apiMarketplace = css`
  width: 40%;
  margin-top: 8px;
  order: 1;
`;

export const nonApiMarketplace = css`
  width: 45%;
  margin-top: 8px;
  order: 1;
`;

export const apiLocation = css`
  width: 45%;
  margin-top: 8px;
  order: 4;
`;

export const nonApiLocation = css`
  width: 45%;
  order: 3;
  margin-right: auto;
  margin-left: 26px;
  margin-top: 0px;
`;

export { ConnectAccount, ConnectAnother };
